// mock t function for i18next scanner to pick up
const t = (x: string) => x

export enum TimeFilterColumn {
    Faelligkeit = 0,
    Rechnungsdatum = 1,
    Wertestellung = 2,
    Eingangsdatum = 3,
}

export const TimeFilterColumnLabels: {[k: string]: string} = {
    [TimeFilterColumn.Faelligkeit]: t('ix2048:enum.TimeFilterColumn.Faelligkeit'),
    [TimeFilterColumn.Rechnungsdatum]: t('ix2048:enum.TimeFilterColumn.Rechnungsdatum'),
    [TimeFilterColumn.Wertestellung]: t('ix2048:enum.TimeFilterColumn.Wertestellung'),
    [TimeFilterColumn.Eingangsdatum]: t('ix2048:enum.TimeFilterColumn.Eingangsdatum'),
}

export const timeFilterColumnToOpts = (t: Function, settings: any) => {
    const opts = []

    for(let x in TimeFilterColumn) {
        if (!isNaN(Number(x))) { continue }


        opts.push({
            name: t(TimeFilterColumnLabels[TimeFilterColumn[x as keyof typeof TimeFilterColumn]]),
            value: TimeFilterColumn[x as keyof typeof TimeFilterColumn],
        })
    }

    return opts
}
